export { default } from './CommentStat';



// WEBPACK FOOTER //
// ./src/components/Comment/CommentStat/index.js